export enum RoleNameEnum {
  Root = "Root",
  SuperAdmin = "SuperAdmin",
  Admin = "Admin",
  AdminAssistant = "AdminAssistant",
  Manager = "Manager",
  SupplierAdmin = "SupplierAdmin",
  Supplier = "Supplier",
  Viewer = "Viewer",
  Finance = "Finance",
  Approver = "Approver",
  ApproverDone = "ApproverDone",
  Driver = "Driver",
}
